import React from 'react';
import { stats } from '../../data/mock';

const StatsSection = () => {
  return (
    <section className="py-16 lg:py-20 bg-[#1a1c1b]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
          {stats.map((stat) => (
            <div key={stat.label} className="text-center py-2">
              <div className="text-[#FF0000] text-xl sm:text-2xl lg:text-4xl font-bold mb-1 lg:mb-2">
                {stat.value}
              </div>
              <p className="text-gray-600 text-xs sm:text-sm font-medium uppercase tracking-wider leading-tight">
                {stat.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
